import { render, staticRenderFns } from "./PricingCardStyle2.vue?vue&type=template&id=ca2ef4e4"
import script from "./PricingCardStyle2.vue?vue&type=script&lang=js"
export * from "./PricingCardStyle2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports